<template>
    <div
        v-if="partners && partners.length"
        class="md-partner layout1 mg-bg"
        :style="{
            ...spaceStyle,
            ...colorStyle
        }"
    >
        <site-title class="f-col" :title="title" />
        <InfiniteSlide :speed="100">
            <div class="partner-container">
                <div class="partner-item" v-for="(partner, i) in partners"  :key="i">
                    <partner-logo :partner="partner" />
                </div>
            </div>
        </InfiniteSlide>
    </div>
</template>

<script>
import partnerLogo from '../partner-logo.vue';
import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';
import InfiniteSlide from '@/components/infinite-slide.vue';

export default {
    mixins: [spaceMixin(), colorMixin()],
    data: function() {
        return {
            title: '',
            bgType: 'color',
            bgColor: '',
            fullColumn: false,
            partners: []
        };
    },
    components: {
        partnerLogo,
        InfiniteSlide
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.md-partner.layout1 {
    .site-title {
        padding-bottom: 30px;
        @include media-800 {
            padding-bottom: 15px;
        }
    }
    .partner-container {
        display: flex;
        flex-wrap: nowrap;
    }
    .partner-item {
        width: auto;
        height: 60px;
        padding: 0 45px;
    }
    .partner-img {
        filter: grayscale(1);
        cursor: pointer;
        &:hover {
            filter: none;
        }
    }
}
</style>
